module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"selected_period":"Selected Period","compared_period":"Compared Period","radar":"Radar","radarTooltip":"A radar chart useful for depicting how much performance has increased/decreased for individual KPIs between the selected and comparison periods.","radarTooltip2":"This graph requires that a minimum of three KPIs be selected.","compare_period":"Comparison Period"}}')
  delete Component.options._Ctor
}
